<template>
  <div>
    <!--This is for desktop to be displayed. For phone see file: sidebarRight-->
    <!--Snackbar will be disabled eventually, all it does are letting one know that the module are loaded in a fancy pink way-->
    <v-snackbar v-model="snackbar" :timeout="0" :top="true">
      {{ snackbartext }}
      <v-btn color="pink" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-navigation-drawer fixed app>
      <v-toolbar flat dark>
        <p class="subtitle-1 pl-7 pt-3 font-weight-bold">
          {{ $t("sidebar.Personal Setting") }}
        </p>
      </v-toolbar>
      <v-toolbar flat dark>
        <v-list>
          <v-list-item>
            <v-list-item-title class="subtitle-1 pl-12 font-weight-bold">{{
              fullName
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-toolbar>
      <v-list fill-height>
        <template v-for="item in profileitems">
          <v-list-item :key="item.text" :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.text) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider class="hidden-md-and-up"></v-divider>
      </v-list>
    </v-navigation-drawer>
    <v-container fill-height>
      <router-view @snackbarevent="updateSnackbar" />
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import messages from "./modules/lang/main/export";

export default {
  i18n: { messages },
  data() {
    return {
      routename: "",
      scrolled: false,
      snackbar: false,
      snackbartext: "",
      snackbartimeout: null,
      drawer: { visible: null, clipped: false },
      profileitems: [
        // {
        //   icon: "home",
        //   text: "sidebar.Dashboard",
        //   link: { name: "dashboard" }
        // },
        // { icon: "fas fa-rss-square", text: "sidebar.Manage Feeds", link: { name: "managefeeds" }},
        { icon: "", text: "sidebar.BackToFrontPage", link: "/front" },
        {
          icon: "fas fa-user",
          text: "sidebar.Profile",
          link: { name: "editprofile" }
        },
        {
          icon: "fas fa-newspaper",
          text: "sidebar.Frontpage feeds",
          link: { name: "editfrontpagesettings" }
        },
        {
          icon: "fas fa-list",
          text: "sidebar.Your Articles",
          link: { name: "listarticles" }
        },
        {
          icon: "fas fa-plus",
          text: "sidebar.Create",
          link: { name: "createarticle" }
        },
        // { icon: "fas fa-inbox", text: "sidebar.Inbox", link: { name: "inbox" }},
        // { icon: "fas fa-heart", text: "sidebar.Follows", link: { name: "follows" }},
        {
          icon: "fas fa-sign-out-alt",
          text: "sidebar.Logout",
          link: { name: "logout" }
        }
      ]
    };
  },
  methods: {
    ...mapMutations(["HISTORY_REMOVE"]),
    goToHistory() {
      this.$router.push(this.getHistory);
      this.HISTORY_REMOVE();
    },
    updateSnackbar(message) {
      clearTimeout(this.snackbartimeout);
      this.snackbartimeout = setTimeout(() => {
        this.snackbar = false;
      }, 3000);
      this.snackbartext = message;
      this.snackbar = true;
    },
    checkRouteName(name) {
      return this.routename == name;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
    }
  },
  computed: {
    ...mapGetters(["getHistory", "fullName"])
  },
  mounted() {
    this.routename = this.$route.name;
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
